// extracted by mini-css-extract-plugin
module.exports = {"media-gallery":"external-media_media-gallery__2T9uU"};